import {ThemeContext} from "@emotion/react";
import {Tooltip, styled, tooltipClasses} from "@mui/material";
import React from "react";

const CustomWidthTooltip = styled(({className, ...props}) => <Tooltip {...props} classes={{popper: className}} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FDF3D8",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: 220,
    fontSize: "12px",
    border: "1px solid #dadde9",
    padding: "20px",
    borderRadius: "10px",
  },
});

const ToolTip = (props) => {
  return <CustomWidthTooltip {...props}>{props.children}</CustomWidthTooltip>;
};

export default ToolTip;
